// extracted by mini-css-extract-plugin
export default {"filterBlockWrapper":"styles_filterBlockWrapper__wnsc0","filterItem":"styles_filterItem__xhI21","active":"styles_active__yr0dy"};